import AdUnit from "../../core/AdUnit";
import { injectScript, getRandomString } from "../../utils/utils";
import { AdvIDPrefix, AdUnitStatus, event, GOOGLE_PUB_TAG_URL } from "../../utils/const";
import LibLoader from "../../utils/LibLoader";

class GooglePubTag extends AdUnit {
	constructor(cfg) {
		super(cfg);
		
		this.controller = null;
		
		this._init();
	}
	
	_init() {
		if (!window.googletag?.cmd) {
			return LibLoader.load(GOOGLE_PUB_TAG_URL,
				() => { this._init(); },
				() => {
					this.localEmitter.emit(event.Ad.AdError, { code: 9 });
					this.emitter.emit(event.Player.TagCompleteRequest, { tid: this.config.params.tid, success: false });
				});
		}
		
		this.logger.log(`[GooglePubTag - ${this.config.playerConfig.zone} / ${this.config.params.tid}] _init() called`, this.config);
		
		this.slot.id = this.advID = AdvIDPrefix.GPT + getRandomString();
		this.controller = window.googletag;
		
		this.status = AdUnitStatus.LOADED;
	}
	
	_onImpression = () => {
		this.logger.log(`[GooglePubTag - ${this.config.playerConfig.zone} / ${this.config.params.tid}] _onImpression called`, this);
		this.localEmitter.emit(event.Ad.AdImpression);
	}
	
	_onRenderEnded = ({ isEmpty }) => {
		if (this.timers.startAd) {
			clearTimeout(this.timers.startAd);
			this.timers.startAd = null;
		}
		
		if (isEmpty) {
			this.logger.log(`[GooglePubTag - ${this.config.playerConfig.zone} / ${this.config.params.tid}] no ads`, this);
			this.localEmitter.emit(event.Ad.AdError);
			this.emitter.emit(event.Player.TagCompleteRequest, { tid: this.config.params.tid, success: false });
		} else {
			this.timers.bannerShow = setTimeout(() => {
				this.logger.log(`[GooglePubTag - ${this.config.playerConfig.zone} / ${this.config.params.tid}] complete banner show`, this);
				this.localEmitter.emit(event.Ad.AdVideoComplete);
			}, this.config.timeouts.gpt || 15000);
			
			this.logger.log(`[GooglePubTag - ${this.config.playerConfig.zone} / ${this.config.params.tid}] _onRenderEnded() called`, this);
			this.localEmitter.emit(event.Ad.AdVideoStart);
		}
	}
	
	start = () => {
		this.logger.log(`[GooglePubTag - ${this.config.playerConfig.zone} / ${this.config.params.tid}] start() called`, this);
		
		this.slot.classList.add("active");
		
		this.timers.startAd = setTimeout(() => {
			this.logger.log(`[GooglePubTag - ${this.config.playerConfig.zone} / ${this.config.params.tid}] startAd timeout`);
			this.localEmitter.emit(event.Ad.AdError);
		}, this.config.timeouts.googlestart || 5000);
		
		this.controller.cmd.push(() => {
			this.controller.pubads().addEventListener("slotRenderEnded", this._onRenderEnded);
			this.controller.pubads().addEventListener("impressionViewable", this._onImpression);
			
			this.controller.enableServices();
			
			const { slot } = JSON.parse(this.config.template);
			
			this.controller
				.defineSlot(slot, [[300, 250], [336, 280]], this.slot.id)
				.addService(googletag.pubads());
			
			// Enable the PubAdsService.
			// googletag.enableServices();
			this.controller.display(this.slot.id);
		});
		
		// this.controller.enableServices();
		// this.controller.display(this.slot.id);
	}
	
	pause = () => {
		this.adsManager.pause && this.adsManager.pause();
	}
	resume = () => {
		this.adsManager.resume && this.adsManager.resume();
	}
	resize = (width, height) => {
		this.adsManager && this.adsManager.resize(width, height, this.controller.ViewMode.NORMAL);
	}
	getDuration = () => {
		try {
			return this.adsManager && this.adsManager.getCurrentAd().getDuration();
		} catch (e) {}
	}
	getCurrentTime = () => {
		try {
			return this.adsManager && this.adsManager.getCurrentAd().getDuration() - this.adsManager.getRemainingTime();
		} catch (e) {}
	}
	getVolume = () => {
		return this.adsManager.getVolume();
	}
	setVolume = (volume) => {
		return this.adsManager.setVolume(volume);
	}
}

export default GooglePubTag;
//
// // This listener will be called when a slot's creative iframe load event

// // fires.
// this.controller.pubads().addEventListener("slotOnload", (event) => {
// 	const slotId = event.slot.getSlotElementId();
// 	printEventMessage("Creative iframe load event has fired.", slotId);
// });

//
// // This listener will be called when the specified service actually
// // sets an ad request for a slot. Each slot will fire this event, even
// // though they may be batched together in a single request if single
// // request architecture (SRA) is enabled.
// this.controller.pubads().addEventListener("slotRequested", (event) => {
// 	const slotId = event.slot.getSlotElementId();
// 	requestedTimestamp[slotId] = Date.now();
// 	printEventMessage("Slot has been requested.", slotId);
// });
//
// // This listener will be called when an ad response has been received for
// // a slot.
// this.controller.pubads().addEventListener("slotResponseReceived", (event) => {
// 	const slotId = event.slot.getSlotElementId();
// 	printEventMessage("Ad response has been received.", slotId);
// });
//
// // This listener will be called whenever the on-screen percentage of an ad
// // slot's area changes.
// this.controller.pubads().addEventListener("slotVisibilityChanged", (event) => {
// 	const slotId = event.slot.getSlotElementId();
//
// 	// Record details of the event.
// 	const details = { "Visible area": `${event.inViewPercentage}%` };
//
// 	printEventMessage("Visibility has changed.", slotId, details);
// });